/**
 * The reorder code as a badge — purchasing's vocabulary, served by the SERVER
 * (`isg_common.org.reorder_types.meaning`), never re-typed here: vault's picker kept
 * its own copy of the words and it drifted.
 *
 * Held (R/S) green · made (P/M/O) blue · bought to order (N) amber · unknown grey.
 * The tooltip says what the code means and whose warehouses it is for.
 */
import { escapeHtml } from '@isg/ui-kit';

export function reorderBadge(r, { long = false } = {}) {
  if (!r || !r.code) return '';
  const tone = r.varies ? 'gray' : r.stocked ? 'green' : r.made ? 'blue' : r.stocked === false ? 'amber' : 'gray';
  const title = [r.company ? `${r.company}:` : 'All buying companies:', r.label, '—', r.note].filter(Boolean).join(' ');
  const text = long ? `${r.code} · ${r.label}` : r.code;
  return `<span class="badge badge-${tone}" title="${escapeHtml(title)}">${escapeHtml(text)}</span>`;
}
